/*
 * Deskon - "London Showroom" line in the mobile navigation drawer, and its popup.
 *
 * A SEPARATE FILE ON PURPOSE. The drawer itself is built by assets/deskon-nav-drawer.js. This
 * script only adds one row under the drawer's head (logo + close) once that build exists, so the
 * drawer script stays untouched and this feature can be switched off on its own: set
 * "enabled": false in snippets/deskon-nav-drawer-data.liquid.
 *
 * THE POPUP IS ITS OWN, NOT THE HOMEPAGE SECTION'S. The section's popup only exists on the
 * homepage; the menu is on every page. So the popup is built here, once, appended to <body>, with
 * the same look as the section's (see assets/deskon-nav-showroom.css). Its texts come from the
 * JSON in snippets/deskon-nav-drawer-data.liquid - if the section's popup texts are changed, change
 * them there too.
 *
 * TAPPING THE ROW CLOSES THE DRAWER FIRST. The drawer traps focus and locks the scroll; opening
 * the popup on top of it would fight both. The drawer closes, then the popup opens.
 *
 * IT RE-APPLIES. The header section is re-rendered by the theme editor and the drawer is rebuilt
 * with it; an observer on #header-group puts the row back. The guard is the row's presence.
 */

(function () {
  'use strict';

  var TAG = '[deskon-nav-showroom]';

  function readData() {
    var tag = document.getElementById('deskon-nav-showroom-data');
    if (!tag) return null;
    try {
      return JSON.parse(tag.textContent);
    } catch (error) {
      console.warn(TAG, 'data is not valid JSON', error);
      return null;
    }
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  /* "London Showroom" -> "London " + <em>Showroom</em>: the last word in italic, as in the footer. */
  function fillTitle(node, text) {
    var words = String(text || '').trim().split(/\s+/);
    if (words.length > 1) {
      var last = words.pop();
      node.appendChild(document.createTextNode(words.join(' ') + ' '));
      var em = el('em');
      em.textContent = last;
      node.appendChild(em);
    } else {
      node.textContent = words[0] || '';
    }
  }

  function closeDrawer() {
    var drawer = document.querySelector('header-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
      return;
    }
    var details = (drawer || document).querySelector('details');
    if (!details) return;
    details.classList.remove('menu-open');
    details.removeAttribute('open');
  }

  /* ------------------------------------------------------------------ popup */

  var popup = null;

  function buildPopup(data) {
    var p = data.popup || {};
    var overlay = el('div', 'dk-showroom-pop');
    overlay.hidden = true;

    var dialog = el('div', 'dk-showroom-pop__dialog');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'DeskonNavShowroomTitle');
    dialog.tabIndex = -1;

    if (p.eyebrow) {
      var eyebrow = el('p', 'dk-showroom-pop__eyebrow');
      eyebrow.textContent = p.eyebrow;
      dialog.appendChild(eyebrow);
    }

    var title = el('h2', 'dk-showroom-pop__title');
    title.id = 'DeskonNavShowroomTitle';
    title.textContent = p.title || '';
    dialog.appendChild(title);

    if (p.text) {
      var text = el('p', 'dk-showroom-pop__text');
      text.textContent = p.text;
      dialog.appendChild(text);
    }

    var close = el('button', 'dk-showroom-pop__close');
    close.type = 'button';
    close.textContent = p.button || 'Close';
    dialog.appendChild(close);

    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    function onKey(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        hide();
      } else if (event.key === 'Tab') {
        /* Only one control inside: keep focus on it. */
        event.preventDefault();
        close.focus();
      }
    }

    function show() {
      overlay.hidden = false;
      document.documentElement.classList.add('dk-showroom-lock');
      document.addEventListener('keydown', onKey);
      dialog.focus();
    }

    function hide() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      document.documentElement.classList.remove('dk-showroom-lock');
      document.removeEventListener('keydown', onKey);
    }

    close.addEventListener('click', hide);
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) hide();
    });

    return { show: show, hide: hide };
  }

  function openPopup(data) {
    if (!popup) popup = buildPopup(data);
    closeDrawer();
    /* Next frame, so the drawer's own close (focus release, scroll unlock) runs first. */
    requestAnimationFrame(function () {
      popup.show();
    });
  }

  /* -------------------------------------------------------------- menu row */

  function buildRow(data) {
    var row = el('button', 'dk-nav__showroom');
    row.type = 'button';
    row.setAttribute('aria-haspopup', 'dialog');

    /* The dot is an SVG circle, not a rounded box: a 7-8px box with border-radius lands on
       half-pixels at 2x/3x and is rasterised as an oval on some phones. A vector circle is
       always round. */
    var dot = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    dot.setAttribute('class', 'dk-nav__showroom-dot');
    dot.setAttribute('viewBox', '0 0 10 10');
    dot.setAttribute('aria-hidden', 'true');
    dot.setAttribute('focusable', 'false');
    var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    circle.setAttribute('cx', '5');
    circle.setAttribute('cy', '5');
    circle.setAttribute('r', '5');
    circle.setAttribute('fill', 'currentColor');
    dot.appendChild(circle);
    row.appendChild(dot);

    var label = el('span', 'dk-nav__showroom-label');
    fillTitle(label, data.label);
    row.appendChild(label);

    if (data.status) {
      var status = el('span', 'dk-nav__showroom-status');
      status.textContent = data.status;
      row.appendChild(status);
    }

    row.addEventListener('click', function () {
      openPopup(data);
    });
    return row;
  }

  function apply() {
    var data = readData();
    if (!data || data.enabled === false) return false;

    var nav = document.querySelector('header-drawer .dk-nav');
    if (!nav) return false;
    if (nav.querySelector('.dk-nav__showroom')) return true;

    var head = nav.querySelector('.dk-nav__head');
    var row = buildRow(data);
    if (head && head.nextSibling) nav.insertBefore(row, head.nextSibling);
    else if (head) nav.appendChild(row);
    else nav.insertBefore(row, nav.firstChild);
    return true;
  }

  [0, 100, 300, 800, 1600, 3000].forEach(function (delay) {
    setTimeout(apply, delay);
  });
  window.addEventListener('load', apply);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(apply, 50);
  });

  var group = document.getElementById('header-group');
  if (group && window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    }).observe(group, { childList: true, subtree: true });
  }
})();
